import { Box, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import useTemplateSx from '../../hooks/useTemplateSx';
import { typography } from '../../../../theme/tokens/typography';

export default function Field({
  errorMessage,
  helperText,
  error,
  sx,
  InputLabelProps,
  stacked = false,
  label,
  ...props
}) {
  const styles = useTemplateSx();
  const resolvedHelper = error && errorMessage ? errorMessage : helperText;

  if (stacked) {
    return (
      <Box sx={{ ...styles.formFieldSpacing, ...sx }}>
        {label ? (
          <Typography component="label" sx={styles.formLabel}>
            {label}
          </Typography>
        ) : null}
        <TextField
          size="small"
          fullWidth
          error={error}
          helperText={resolvedHelper}
          sx={styles.formField}
          {...props}
        />
      </Box>
    );
  }

  return (
    <TextField
      size="small"
      fullWidth
      label={label}
      error={error}
      helperText={resolvedHelper}
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      sx={{ ...styles.formField, ...sx , gap: '2.8px',
        '& .MuiFormHelperText-root':{ fontSize:'0.7143rem' , mt:0} ,
        '& .MuiFormLabel-root.MuiInputLabel-root':{ fontSize: typography.fontSizeSm}
      }}
      {...props}
    />
  );
}
